import React, { useState } from 'react';
import { Alert, Box, Button, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { KeyOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { apiFetch } from '../services/api';

export default function PierwszaZmianaHasla(){
  const location=useLocation();
  const navigate=useNavigate();
  const token=location.state?.token_zmiany_hasla;
  const login=location.state?.login||'';
  const [haslo,setHaslo]=useState('');
  const [powtorz,setPowtorz]=useState('');
  const [blad,setBlad]=useState('');
  const [sukces,setSukces]=useState(false);
  const [wysylanie,setWysylanie]=useState(false);
  const [pokazHaslo,setPokazHaslo]=useState(false);
  const [pokazPowtorz,setPokazPowtorz]=useState(false);

  if(!token && !sukces) return <Navigate to="/logowanie" replace/>;

  const submit=async e=>{
    e.preventDefault();
    setBlad('');
    if(haslo.length<8 || !/[A-ZĄĆĘŁŃÓŚŹŻ]/.test(haslo) || !/[^A-Za-z0-9ĄĆĘŁŃÓŚŹŻąćęłńóśźż]/.test(haslo)){setBlad('Hasło musi mieć co najmniej 8 znaków, co najmniej jedną wielką literę i jeden znak specjalny.');return;}
    if(haslo!==powtorz){setBlad('Hasła nie są takie same.');return;}
    setWysylanie(true);
    try{
      await apiFetch('/haslo/pierwsza-zmiana',{
        method:'POST',
        body:JSON.stringify({token_zmiany_hasla:token,haslo})
      });
      setSukces(true);
    }catch(e){setBlad(e.message);}finally{setWysylanie(false);}
  };

  return <Box sx={{minHeight:'100vh',bgcolor:'#f4f7fb',display:'grid',placeItems:'center',p:2}}>
    <Paper elevation={0} sx={{width:'100%',maxWidth:500,p:{xs:3,sm:4.5},borderRadius:4,border:'1px solid #e1e8f2',boxShadow:'0 18px 55px rgba(18,46,84,.10)'}}>
      <Box sx={{width:48,height:48,borderRadius:2.5,bgcolor:'#eaf2ff',color:'#2364d8',display:'grid',placeItems:'center',mb:2.5}}><KeyOutlined/></Box>
      <Typography variant="h5" fontWeight={900}>Ustaw własne hasło</Typography>
      <Typography color="text.secondary" sx={{mt:.7,mb:3}}>
        {login ? `Pierwsze logowanie do konta ${login}.` : 'Pierwsze logowanie.'}
      </Typography>

      {location.state?.message&&<Alert severity="info" sx={{mb:2}}>{location.state.message}</Alert>}
      {blad&&<Alert severity="error" sx={{mb:2}}>{blad}</Alert>}

      {!sukces ? <Box component="form" onSubmit={submit} sx={{display:'grid',gap:2}}>
        <TextField
          type={pokazHaslo?'text':'password'}
          label="Nowe hasło"
          value={haslo}
          onChange={e=>setHaslo(e.target.value)}
          helperText="Min. 8 znaków, 1 wielka litera i 1 znak specjalny. Hasło musi być inne niż hasło tymczasowe."
          required
          InputProps={{endAdornment:<InputAdornment position="end"><IconButton onClick={()=>setPokazHaslo(v=>!v)} edge="end">{pokazHaslo?<VisibilityOff/>:<Visibility/>}</IconButton></InputAdornment>}}
        />
        <TextField
          type={pokazPowtorz?'text':'password'}
          label="Powtórz nowe hasło"
          value={powtorz}
          onChange={e=>setPowtorz(e.target.value)}
          required
          InputProps={{endAdornment:<InputAdornment position="end"><IconButton onClick={()=>setPokazPowtorz(v=>!v)} edge="end">{pokazPowtorz?<VisibilityOff/>:<Visibility/>}</IconButton></InputAdornment>}}
        />
        <Button type="submit" variant="contained" disabled={wysylanie} sx={{minHeight:46,textTransform:'none',fontWeight:800}}>
          {wysylanie?'Zapisywanie...':'Ustaw hasło'}
        </Button>
      </Box> : <>
        <Alert severity="success" sx={{mt:2}}>Hasło zostało ustawione. Możesz zalogować się do systemu.</Alert>
        <Button onClick={()=>navigate('/logowanie')} variant="contained" fullWidth sx={{mt:2,textTransform:'none'}}>Przejdź do logowania</Button>
      </>}

      {!sukces&&<Button component={Link} to="/logowanie" sx={{mt:2,textTransform:'none'}}>Wróć do logowania</Button>}
    </Paper>
  </Box>;
}
